<template>
  <div class="paging-containner">
    <div class="paging-center">
      <div class="paging-left paging-arrowhead" @click="prevPage" role="button" aria-label="prevPage">
        <a href="javascript:;" style="color: inherit"><img src="../images/top1.png" alt /></a>
      </div>
      <div class="select-paging-all">
        <div class="input-paging-btn" @click.stop >
          <input type="tel" name="tel" autocomplete="off" oninput = "value=value.replace(/[^\d]/g,'')" ref="inputNum" v-if="$store.state.innerWidth>1080" class="input-paging Regular" @input="setPage" />
          <input type="tel" name="tel" autocomplete="off" oninput = "value=value.replace(/[^\d]/g,'')" ref="inputNum" disabled v-if="$store.state.innerWidth<=1080" class="input-paging Regular" @input="setPage" />
          <i  class="icon-arrow-down input-paging-arrow Bold" @click="selecPagingList"></i>
        </div>
        <div class="select-paging-list select-courses-paging-list">
          <div class="select-paging-one" v-if="page>0&&page<=2||numBars<=5&&numBars>0">
            <div
              class="select-paging-item"
              @click="changeConditions(index)"
              v-for="index of numBars"
              v-if="index<6&&numBars>1"
              :key="index"
            >{{index}}</div>
            <div class="select-paging-item" v-if="numBars>5">...</div>
            <div class="select-paging-item" v-if="numBars>5" @click="changeConditions(numBars)">{{numBars}}</div>
          </div>
          <div class="select-paging-two" v-else-if="page>2&&page<(numBars-5)&&numBars>0">
            <div class="select-paging-item" @click="changeConditions(1)">1</div>
            <div class="select-paging-item">...</div>
            <div
              class="select-paging-item"
              @click="changeConditions(index)"
              v-for="index of numBars"
              v-if="index<(5+page)&&index>=page"
              :key="index"
            >{{index}}</div>
            <div class="select-paging-item">...</div>
            <div class="select-paging-item" @click="changeConditions(numBars)">{{numBars}}</div>
          </div>
          <div class="select-paging-three" v-else>
            <div class="select-paging-item" @click="changeConditions(1)">1</div>
            <div class="select-paging-item">...</div>
            <div
              class="select-paging-item"
              @click="changeConditions(index)"
              v-for="index of numBars"
              v-if="numBars>=index&&index>(numBars-5)&&numBars>0"
              :key="index"
            >{{index}}</div>
          </div>
        </div>
      </div>
      <div class="paging-right paging-arrowhead" @click="nextPage" role="button" aria-label="nextPage">
        <a href="javascript:;" style="color: inherit"><img src="../images/top1.png" alt /></a>
      </div>
    </div>
       <!-- <div
          class="mask maskJia"
          @click="closePopup"
          :class="{'show':(showJobFunction||showExperience),'maskPC':$store.state.innerWidth>768}"
        ></div> -->
  </div>
</template>
<script>

export default {
  data() {
    return {
      page: 1,
      numBars:1,
      timer:null,
      showJobFunction: false,
      showExperience: false,
      rowTimes:0
    };
  },
  props: [
  "courseListAll",
  "toRows"
  ],
  created() {

  },
  mounted() {
   
    this.$refs.inputNum.value = 1;
     var that = this;
    //  setTimeout(function(){
      if(that.$route.query.page){
        that.page = parseInt(that.$route.query.page);
        this.numBars = this.page;
        that.$refs.inputNum.value = parseInt(that.$route.query.page);
      }
    //  },1000)
  },

  methods: {
    clearTime:function(){
      clearTimeout(this.timer);
      this.timer = null;
    },
    changePageOne:function(){
       this.page = 1;
    },
    prevPage:function(){
      if(this.page>1){
        this.page = this.page-1;
      }else{
         this.page = 1;
      }
      this.closeSelecPagingList();
    },
    nextPage:function(){
       if(this.page<this.numBars){
        this.page = this.page+1;
      }else{
         this.page = this.numBars;
      }
      this.closeSelecPagingList();
    },
    setPage:function(){
      var that = this;
      this.timer = setTimeout(function(){
        that.page = that.$refs.inputNum.value;
        if(that.page !=''){
          that.page = parseInt(that.page);
        }
      },800)
      
    },
    changeConditions: function(index) {
      var that = this;
      this.clearTime();
      this.page = index;
      this.closeSelecPagingList();
    },
    closeSelecPagingList: function() {
      var that = this;
      let selectPagingList = document.getElementsByClassName(
        "select-paging-list"
      )[0];
      let openPage = document.getElementsByClassName("openPage")[0];
      if(selectPagingList != undefined){
        selectPagingList.classList.remove("openPage");
      }
      
    },
    selecPagingList: function() {
      
      var that = this;
      let selectPagingList = document.getElementsByClassName(
        "select-paging-list"
      )[0];
   
      let openPage = document.getElementsByClassName("openPage")[0];
      if (openPage == undefined) {
        selectPagingList.classList.add("openPage");
      } else {
        selectPagingList.classList.remove("openPage");
      }
    }
  },
  watch: {
    page:function(){
      var that = this;
        if(that.page>that.numBars){
          that.page = that.numBars;
        }else if(that.page == ''){
          that.page = 1;
        }else if(isNaN(that.page) == false && isNaN(that.page) !=''){
           that.page = 1;
        }
        that.$refs.inputNum.value = that.page;
        var rowTimes = Math.ceil(that.page/5)-1;
        var smallPaging = that.page%5==0?5:that.page%5;   
        if(that.rowTimes != rowTimes){
          that.$emit('changeRow',rowTimes);
        }
        that.rowTimes = rowTimes;
        that.$emit('changePaging',smallPaging);
        that.closeSelecPagingList();
   
      
    },
    toRows:{
      handler(newValue, oldValue){
        this.toRows = newValue;
        var pages = parseInt(this.toRows)/20;
        this.numBars =  Math.ceil(pages);
        this.numBars == 0?this.numBars = 1:'';
      },  
      deep:true
    },
    courseListAll:{
      handler(newValue, oldValue){
        this.courseListAll = newValue;
     
      },  
      deep:true
    }
  }
};
</script>